export const SUCCESS_BAR_CHART_STORE = "SUCCESS_BAR_CHART_STORE";
export const ERROR = "ERROR";
export const LOADING = "LOADING";
export const SUCCESS_GET_DEFAULT_ACTIVITY_NAMES =
  "SUCCESS_GET_DEFAULT_ACTIVITY_NAMES";
